import styled from 'styled-components';

import UnstyledContainer from '../common/container';

export const Container = styled(UnstyledContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Headline = styled.h1`
  margin-top: 18px 0 0; 
`;
